import { useState } from 'react'
import { Checkbox, Button, Label } from 'flowbite-react';

const viewOptions = [
  "Autorización al Proceso de Visita Domiciliaria",
  "DatosGenerales",
  "Bienes Inmuebles / Muebles",
  "Inmueble Casa / Departamento",
  "Información Familiar",
  "Croquis Domicilio",
  "Referencias laborales",
  "Referencias personales",
  "Referencias vecinales",
  "Fotografías de Visita Domiciliaria",
  "Conclusiones de Visita Domiciliaria"
]

export const DescargarFormulariosVD_print = () => {
  const [selectedViews, setSelectedViews] = useState<string[]>([])

  const handleViewToggle = (view: string) => {
    setSelectedViews(prev =>
      prev.includes(view)
        ? prev.filter(v => v !== view)
        : [...prev, view]
    )
  }

  const handlePrint = () => {
    console.log("Views to print:", selectedViews)
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Select Views to Print</h2>
      <div className="space-y-4">
        {viewOptions.map((view, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Checkbox
              id={`view-${index}`}
              checked={selectedViews.includes(view)}
            />
            <Label
              htmlFor={`view-${index}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {view}
            </Label>
          </div>
        ))}
      </div>
      <Button 
        onClick={handlePrint} 
        className="mt-6"
        disabled={selectedViews.length === 0}
      >
        Print Selected Views
      </Button>
    </div>
  )
}